import { EColors } from "common/styles";

export const benefits = [
    {
      number: 1,
      title: 'Чистота',
      text: "Ви можете бути впевнені, що кожна крапля пального, яку використовуєте, допомагає зберегти чистоту вашого двигуна та навколишнього середовища.",
      color:`${EColors.primary_200}`,
    },
    {
      number: 2,
      title: 'Надійність',
      text: "Ви можете подорожувати спокійно, знаючи, що ваш двигун отримує оптимальні характеристики пального.",
      color:`${EColors.accent_300}`,
    },
    {
      number: 3,
      title: 'Висока якість',
      text: "Ви отримуєте потужність та ефективність, які забезпечують комфортне та динамічне водіння. Пальне відповідає найвищим стандартам якості, що гарантує оптимальну роботу вашого двигуна.",
      color:`${EColors.primary_200}`,
    },
     {
      number: 4,
      title: 'Власний імпорт',
      text: "Ви можете подорожувати спокійно, знаючи, що ваш двигун отримує оптимальні характеристики пального.",
      color:`${EColors.accent_300}`,
    },
  ]